export default function Spinner({small = false}) {
    return (
        <div className={"spinner-grow " + (small ? 'spinner-grow-sm': '')} role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
};